import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { DropdownItem } from "@similarweb/ui-components";

export const StyledDropdownItem = styled(DropdownItem)`
    height: 44px;
    margin: 0 8px;
    max-width: 97%;
`;

export const StyledDropdownContainer = styled.div`
    position: relative;
    & .DropdownContent-search {
        color: ${colorsPalettes.carbon[500]};
    }
`;
